<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
  <Pagesubtitle :subTitle="$store.getters['dash/agency'].isClientName ? 'Invite clients to collaborate on this account.' : 'Invite colleagues to collaborate on this account.'" />
  <div v-if="false" class="text-center">
    <div class="inline-block w-100 my-20">
      <img class="mx-auto w-32" src="@/assets/images/misc/collaborators.png"/>
      <div v-if="$store.getters['dash/subscription'].isTrial">
        <p  class="font-medium text-lg">Due to risk of abuse, we've disabled inviting collaborators on our trial. </p>
        <p class="my-8">Please reach out to us if you'd like us to activate this feature for your trial!</p>
        <vs-button class="w-full" @click="chatToUs">Talk to us</vs-button>
      </div>
      <div v-else>
        <p  class="my-8 font-medium text-lg">Your current plan doesn't support inviting collaborators. You'll need to upgrade to get this feature.</p>
        <vs-button class="w-full" @click="$router.push('/dash/settings/plan')">See Plans</vs-button>
      </div>
    </div>
  </div>
  <div v-else>
  <div v-if="$store.getters['dash/agency'].isClientName" class="p-4 my-3 text-lg font-medium rounded flex items-center lightbrandbg">
    <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
    <span><span>This will invite your client(s) to collaborate on {{$store.state.dash.viewData.business.businessName }}</span>. Collaborators will view the dashboard under your agency brand coloring and logo.</span>
  </div>
  <vs-alert v-if="$store.state.dash.isMulti" class="p-4 my-3 rounded flex items-center text-dark" color="success">
    <span>Collaborators invited here will <span class="font-medium">only have access</span> to <span class="font-medium text-lg">{{ $store.state.dash.viewData.business.businessName }}</span>. If you want a collaborator to have access
    to other spaces, select that space and add them as a collaborator.</span>
  </vs-alert>
  <div class="vx-row">
    <div class="vx-col w-full md:w-2/3">
      <div class="w-full block overflow-auto pb-4 relative">
        <vs-button v-if="
          !($store.getters['dash/subscription'].isTrial && collaborators.length > 0) && 
          collaborators.length !== 0 && 
          collaborators !== false && 
          !($store.getters['dash/haveAccessToCollab'] === 1 && 
          collaborators.length === 1)" 
          @click="askAddCollaboratorM" class="md:min-w-xl mt-5 md:mt-3 float-right md:px-16" >Add Collaborator</vs-button>
        <h4 class="my-5">{{$store.getters['dash/agency'].isClientName ? 'Client ' : ''}}Collaborators of {{ $store.state.dash.viewData.business.businessName }}</h4>
        <div class="text-center py-10" v-if="collLoading">
          <p class="mb-2">Loading collaborators...</p>
          <div class="w-8 h-8 pt_loading inline-block"></div>
        </div>
        <div class="" v-if="collaborators !== false">
          <div v-if="collaborators.length === 0" class="text-center">
            <div class="inline-block w-132 my-10">
              <img class="mx-auto w-48" src="@/assets/images/misc/collaborators.png" />
              <p class="my-8 mt-0 font-medium text-lg">No collaborators yet for this space.</p>
              <vs-button class="w-full" @click="askAddCollaboratorM">Add Collaborator</vs-button>
            </div>
          </div>
          <div v-else>
            <vs-list class="p-5 bg-white rounded">
              <vs-list-item class="px-0 m-0" v-for="collabo in collaborators" :title="collabo.name" :subtitle="collabo.email">
                <template slot="avatar">
                  <vs-avatar />
                </template>
                <span class="mt-3 hidden md:inline-block text-sm mr-2 ">{{ collabo.status }}</span>
                <vs-button class="float-right" color="danger" type="border" icon-pack="feather" icon="icon-trash" @click="showRemoveC(collabo.email, collabo.name)"></vs-button>
                <vs-button class="float-right mr-1" color="primary" type="border" v-if="collabo.status === 'Invite Sent'" @click="resendInvite(collabo.email)">Resend</vs-button>
              </vs-list-item>
            </vs-list>
            <vs-divider/>
            <div v-if="$store.getters['dash/subscription'].isTrial && collaborators.length > 0" class="mb-3 rounded flex items-center">
              <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
              <span>On our trial and "Learn" plans you can only invite one collaborator to this space.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full md:w-1/3">
      <vx-card v-if="$store.getters['dash/agency'].isClientName && feedbackAddressHandle" class="mb-4">
        <h5>Client Login Address</h5>
        <p class="my-4">After first signing up (white-labelled), clients can access your <span class="font-medium">agency-branded dashboard</span> here:</p>
        <vs-input class="w-full text-dark pt_undisable" disabled :value="feedbackAddressHandle + '.feedbackevaluate.com'" />
      </vx-card>
      <vx-card class="">
        <h5 class="mb-3">What can collaborators do?</h5>
        <p class="my-1">
          <feather-icon icon="CheckIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />View Feedback</p>
        <p class="my-1">
          <feather-icon icon="CheckIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Send Invites</p>
        <p class="my-1">
          <feather-icon icon="CheckIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Change survey</p>
        <p class="my-1">
          <feather-icon icon="CheckIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Add to showcase</p>
        <h5 class="my-3">What can't collaborators do?</h5>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Change look and feel</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Change language</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Install web feedback button</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Manage showcase widgets</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Manage spaces</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />Automate collection</p>
        <p class="my-1">
          <feather-icon icon="XIcon" svgClasses="stroke-current text-light w-4 h-4 icontop" />View/add collaborators</p>
      </vx-card>
    </div>
    <vs-popup :title="'Add collaborator for ' + this.$store.state.dash.viewData.business.businessName" :active.sync="askAddCollaborator">
      <div class="">
        <p class="mb-2">This will send a collaboration invitation to this person.</p>
        <p class="my-2 mb-4 text-sm text-light">You'll be able to revoke access later.</p>

        <vs-input v-validate="'required|min:2|max:20'" data-vv-validate-on="blur" data-vv-as="Your name" label="Your name" name="inviterName" placeholder="John Smith" v-model="addCollaboratorInviter" class="w-full" />
        <span class="text-primary my-2" v-if="errors.first('inviterName')">{{ errors.first('inviterName') }}</span>
        <span v-else class="text-dark text-sm mt-2 mb-4 inline-block">This will be shown on the invite, so use a name that the invitee will recognize and trust.</span>

        <vs-input v-validate="'required|min:2|max:20'" data-vv-validate-on="blur" data-vv-as="Invitee first name" label="Invitee first name" name="displayName" placeholder="Jane" v-model="addCollaboratorFN" class="w-full" />
        <span class="text-primary my-2">{{ errors.first('displayName') }}</span>

        <vs-input v-validate="'required|email|max:60'" data-vv-validate-on="blur" name="email" type="email" label="Email" placeholder="john@hancock.com" v-model="addCollaboratorEmail" class="w-full mt-6" />
        <span class="text-primary">{{ errors.first('email') }}</span>

        <vs-button :disabled="errors.any() || addCollaboratorFN.trim() === '' || addCollaboratorEmail.trim() === '' || addCollaboratorInviter.trim() === ''" class="w-full mt-8" @click="addCollaborator">Send Invite</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="holamundo" title="Remove collaborator" :active.sync="showSureRemoveCollaborator" @close="iDontWantToRemoveCollaborator">
      <div class="con-vs-alert mt-3 con-vs-alert-danger">
        <h4 class="titlex vs-alert--title">Are you sure?</h4>
        <div class="vs-alert text-lg">
          If you remove {{ collaboratorRemoveName }} as a collaborator, they will lose all access to {{ $store.state.dash.viewData.business.businessName }}.
        </div>
      </div>
      <vs-button class="w-full mt-8" @click="removeCollaborator">Remove</vs-button>
    </vs-popup>
    </vs-popup>
  </div>
  </div>
</div>
</template>


<script>
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data() {
    return {
      collLoading: true,
      collaborators: false,
      addCollaboratorFN: '',
      addCollaboratorEmail: '',
      addCollaboratorInviter: '',
      collaboratorRemoveName: '',
      feedbackAddressHandle: false,
      collaboratorRemoveEmail: '',
      askAddCollaborator: false,
      showSureRemoveCollaborator: false
    }
  },
  watch: {
    '$store.state.dash.currentMultiLocationI' (v) {
      if (!this._inactive && v !== false) {
        this.loadCollaborators()
      }
    }
  },
  components: {
    Pagesubtitle
  },
  methods: {
    iDontWantToRemoveCollaborator() {
      this.showSureRemoveCollaborator = false
      this.collaboratorRemoveName = ''
      this.collaboratorRemoveEmail = ''
    },
    removeCollaborator() {
      this.showSureRemoveCollaborator = false
      this.$vs.notify({
        title: 'Removing Collaborator',
        text: 'Removing collaborator...',
        color: 'primary',
        time: 2000,
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })
      this.$store.dispatch('dash/REMOVE_COLLABORATOR', {
        email: this.collaboratorRemoveEmail
      }).then((res) => {
        this.$vs.notify({
          title: 'Remove Collaborator',
          text: 'Collaborator has been removed successfully.',
          color: 'success',
          time: 20000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        this.loadCollaborators()
      }).catch(() => {
        this.$vs.notify({
          title: 'Remove Collaborator',
          text: 'Oops! We had an issue trying to remove this collaborator. Please try again or contact support at support@feedback.link',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    },
    showRemoveC(email, name) {
      this.showSureRemoveCollaborator = true
      this.collaboratorRemoveName = name
      this.collaboratorRemoveEmail = email
    },
    resendInvite(email) {
      //this.askAddCollaborator = false
      this.$vs.notify({
        title: 'Resending Invite',
        text: 'Resending invite...',
        color: 'primary',
        time: 5000,
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })
      this.$store.dispatch('dash/ADD_COLLABORATOR', {
        email: email,
        name: '',
        inviterName: '',
        resend: true
      }).then((res) => {
        if (res === 'alreadysent') {
          this.$vs.notify({
            title: 'Invite not sent',
            text: 'You have already resent this invite. Ask the invitee to check their spam folder, and please unmark the email as spam. If they still can\'t find it, please contact support@feedback.link.',
            color: 'warning',
            time: 100000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else {
          this.$vs.notify({
            title: 'Invite has been resent',
            text: 'Ask the invitee to check their spam folder, and unmark the email as spam. If they still can\'t find it, please contact support@feedback.link.',
            color: 'success',
            time: 100000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      }).catch(() => {
        this.$vs.notify({
          title: 'Resend invite',
          text: 'Oops! We had an issue trying to resend this invite. Please try again or contact support at support@feedback.link',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    },
    addCollaborator() {
      this.askAddCollaborator = false
      this.$vs.notify({
        title: 'Adding Collaborator',
        text: 'Adding collaborator...',
        color: 'primary',
        time: 2000,
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })
      this.$store.dispatch('dash/ADD_COLLABORATOR', {
        email: this.addCollaboratorEmail,
        name: this.addCollaboratorFN,
        inviterName: this.addCollaboratorInviter
      }).then((res) => {
        if (res === 'alreadyadded') {
          this.$vs.notify({
            title: 'Add Collaborator',
            text: 'This email has already been added as a collaborator for this space.',
            color: 'warning',
            time: 40000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else if (res === 'hasaccount') {
          this.$vs.notify({
            title: 'Add Collaborator',
            text: 'This email address is already associated with a Feedback Link account. You\'l need to provide a different email address for this person.',
            color: 'warning',
            time: 40000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else if (res === 'needlogo') {
          this.$vs.notify({
            title: 'Logo Needed',
            text: 'You\'ll need to upload a logo for your agency so we can brand the dashboard for your clients. To upload your logo, navigate to your agency feedback link account, then go to Manage > Look and Feel. We need your agency logo in order to invite clients to collaborate.',
            color: 'warning',
            time: 40000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        } else if (res === 'alreadyinvitedotherbrand') {
            
          this.$vs.notify({
          title: 'Already invited',
            text: 'This person has already been invited (and accepted) to another account. You\'l need to provide a different email address.',
            color: 'warning',
            time: 40000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })

        } else {
          this.$vs.notify({
            title: 'Add Collaborator',
            text: 'Collaborator has been added and invite sent.',
            color: 'success',
            time: 20000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.loadCollaborators()
        }
      }).catch(() => {
        this.$vs.notify({
          title: 'Add Collaborator',
          text: 'Oops! We had an issue trying to add this collaborator. Please try again or contact support at support@feedback.link',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    },
    askAddCollaboratorM() {

      let dbName = this.$store.state.auth.firebaseUser.displayName === null ? '' : this.$store.state.auth.firebaseUser.displayName
      if (dbName.indexOf('|pt_aSCI') !== -1) {
        this.addCollaboratorInviter = dbName.substr(0, dbName.indexOf('|pt_aSCI'))
      } else {
        this.addCollaboratorInviter = dbName
      }

      this.addCollaboratorFN = ''
      this.addCollaboratorEmail = ''
      this.askAddCollaborator = true
    },
    loadCollaborators() {
      this.collaborators = false
      this.collLoading = true
      this.$store.dispatch('dash/LIST_COLLABORATORS').then((colbs) => {
        this.feedbackAddressHandle = colbs.feedbackAddressHandle
        colbs = colbs.collaborators
        colbs.sort((a, b) => a.name.localeCompare(b.name))
        this.collaborators = colbs
        this.collLoading = false
      }).catch(() => {
        this.collLoading = false
        this.$vs.notify({
          title: 'Collaborators',
          text: 'Oops! We had an issue trying to get collaborators. Please contact support at support@feedback.link',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    }
  },
  created() {
    //if (this.$store.getters['dash/haveAccessToCollab'] !== false) {
      this.loadCollaborators()
    //}
  }
}
</script>

<style lang="scss">
.icontop {
    position: relative;
    top: 0.1rem;
}


.pt_undisable {
  .vs-inputx.vs-input--input.normal.hasValue {
    opacity: 1;
  }
}
</style>
